import ZigZagCards from "../components/zig-zag-cards/ZigZagCards";
import '../components/cards/CardSection';
import './petroleum.css';
import CardSection from "../components/cards/CardSection";
import Map from "../components/map/Map";
import './realestate.css';

const RealEstate = () => {

  const zigzagCardsData = [
    {
      title: 'Building the Future, Today',
      description: <span>
        <ul>
        <li>
            <span className="zig-zag-card-sub-heading">
              Commercial Land
            </span>
            <span className="zig-zag-card-sub-address">
              Coming Soon FIS & TPS, Marriott
            </span>
            <span className="zig-zag-card-sub-address">
              1029 N. Garnd Canyon  Blvd, Willams, AZ 86046
            </span>
          </li>
          <li>
            <span className="zig-zag-card-sub-heading">
              Commercial Land
            </span>
            <span className="zig-zag-card-sub-address">
              Coming Soon Shopping Center
            </span>
            <span className="zig-zag-card-sub-address">
              31970 Yucaipa Blvd, Yucaipa, CA 92399
            </span>
          </li>
          <li>
            <span className="zig-zag-card-sub-heading">
              Commercial Land
            </span>
            <span className="zig-zag-card-sub-address">
              Coming Soon Staybridge
            </span>
            <span className="zig-zag-card-sub-address">
              Scenic View Drive, Page, AZ
            </span>
          </li>
          <li>
            <span className="zig-zag-card-sub-heading">
              Commercial Land
            </span>
            <span className="zig-zag-card-sub-address">
            Coming Soon Home2 Suites
            </span>
            <span className="zig-zag-card-sub-address">
              Thompson Parkway,L2B1, Johnstown, CO 80534
            </span>
          </li>
          <li>
            <span className="zig-zag-card-sub-heading">
            Commercial Land
            </span>
            <span className="zig-zag-card-sub-address">
            Coming Soon Hotel 
            </span>
            <span className="zig-zag-card-sub-address">
            466 S 900 E Kanab, UT 84741
            </span>
          </li>
        </ul>
      </span>,
      image: '/real-estate-card.jpg',
    }
  ];

  const mapData = [
    {
     name: "Commercial Land (Coming Soon FIS & TPS, Marriott)",
     imageurl: '/petroleum/Yucaipa-Gas-Mart.png',
     address: "1029 N. Garnd Canyon  Blvd, Willams, AZ 86046"
    },
    {
     name: "Commercial Land (Coming Soon Shopping Center)",
     imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
     address: "31970 Yucaipa Blvd, Yucaipa, CA 92399"
    },
    {
     name: "Commercial Land (Coming Soon Staybridge)",
     imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
     address: "Paige"
    },
    {
     name: "Commercial Land (Coming Soon Home2 Suites)",
     imageurl: "/petroleum/Yucaipa-Gas-Mart.png",
     address: "Thompson Parkway,L2B1, Johnstown, CO 80534"
    },
    {
     name: "Commercial Land (Coming Soon Marriott Fairfield Inn & Suites)",
     imageurl: "",
     address: ""
    }    
  ];

  
  return (
    <div className="real-estate-container">
      <div className="banner-section">
        <img src="/real-estate-development.jpg" />
        <h1>
          REAL ESTATE & DEVELOPMENT
        </h1>
      </div>
      <div className="content-section">
        <ZigZagCards cards={zigzagCardsData}  />
        {/* <Map data={mapData} /> */}
      </div>
    </div>
  );

};

export default RealEstate;